import { render, staticRenderFns } from "./ForumTopic.vue?vue&type=template&id=22bafeb1&scoped=true"
import script from "./ForumTopic.vue?vue&type=script&lang=ts"
export * from "./ForumTopic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bafeb1",
  null
  
)

export default component.exports